import React from 'react';
import { Link } from "react-router-dom";

const HomeServices = () => {
  const features = [
    {
      title: 'Web Development',
      key: 'website',
      icon: (
        <img src='../images/internet.png' alt="Website Development" />
      ),
      description: 'We build responsive, user friendly websites tailored to your brand, enhancing online visibility and driving conversions.',
      bgColor: 'bg-purple-200',
    },
    {
      title: 'App Development',
      key: 'mobileApp',
      icon: (
        <img src='../images/app-development.png' alt="App Development" />
      ),
      description: 'Crafting intuitive mobile apps for iOS and Android that engage users and deliver seamless experiences across platforms.',
      bgColor: 'bg-teal-200',
    },
    {
      title: 'Graphic Designing',
      key: 'graphic',
      icon: (
        <img src='../images/graphic-designer.png' alt="Graphic Designing" />
      ),
      description: 'Our expert designs elevate your brand’s identity, from logos to marketing collateral, ensuring consistency and visual appeal.',
      bgColor: 'bg-yellow-200',
    },
    {
      title: 'Digital Marketing',
      key: 'digital',
      icon: (
        <img src='../images/bullhorn.png' alt="Digital Marketing" />
      ),
      description: 'We develop strategic digital marketing campaigns that increase traffic, optimize conversions, and build long term online success.',
      bgColor: 'bg-red-200',
    },
  ];

  return (
    <section id="features" className="py-8 bg-white">
      <div className="px-4 lg:px-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* <div className="text-center">
          <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl xl:text-5xl">
            Boost Your Productivity
          </h2>
          <p className="mt-4 text-base leading-7 text-gray-600 sm:mt-8">
            Enhance your workflow with advanced features
          </p>
        </div> */}
        <div className="grid grid-cols-2 mt-0 md:mt-8 gap-2 text-center sm:grid-cols-2 sm:gap-x-12 gap-y-12 md:grid-cols-4 md:gap-0">
          {features.map((feature, index) => (
        <Link to={`/Service/${feature.key}`}>
            <div
              key={index}
              className={`p-4 sm:p-8 min-h-[16rem] sm:min-h-[320px] rounded flex flex-col justify-center items-center transform transition-all duration-300 shadow-lg md:shadow-none  md:hover:shadow-lg hover:scale-105`}
            >
              <div className={`w-20 h-20 rounded-full ${feature.bgColor} flex justify-center items-center transform transition-all duration-300 hover:scale-110`}>
                {feature.icon}
              </div>
              <h3 className="mt-4  sm:mt-8 text-md md:text-xl font-bold text-gray-900">{feature.title}</h3>
              <p className="mt-2 sm:mt-4 text-[11px] md:text-sm text-gray-600">{feature.description}</p>
            </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
